import { render, staticRenderFns } from "./ImportSupplierPricesHeader.vue?vue&type=template&id=2470b7fc&scoped=true"
import script from "./ImportSupplierPricesHeader.vue?vue&type=script&lang=js"
export * from "./ImportSupplierPricesHeader.vue?vue&type=script&lang=js"
import style0 from "./ImportSupplierPricesHeader.vue?vue&type=style&index=0&id=2470b7fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470b7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2470b7fc')) {
      api.createRecord('2470b7fc', component.options)
    } else {
      api.reload('2470b7fc', component.options)
    }
    module.hot.accept("./ImportSupplierPricesHeader.vue?vue&type=template&id=2470b7fc&scoped=true", function () {
      api.rerender('2470b7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/ImportSupplierPricesHeader.vue"
export default component.exports